const AccommodationStore = {

    namespaced:true,

    state: {
        showGallery:null,
        gallerySet:null,
    },

    mutations: {
        storeShowGallery(state,value){
            //console.log('storeShowGallery',value)
            state.showGallery = value;
        },
        storeGallerySet(state,value){
            //console.log('storeGallerySet',value)
            state.gallerySet = value;
        }
    },

    getters:{

    },

    actions:{

    }
};

export default AccommodationStore;
